import './CityCheckbox.scss';
import { useState, useEffect } from 'react';
import { Checkbox, Icon } from 'semantic-ui-react';
import CloseIcon from '../CloseIcon/CloseIcon.jsx';
import Modal from '../Modal/Modal.jsx';

const CityCheckbox = ({ cities, setCities }) => {
  const [openFullListModal, setOpenFullListModal] = useState(false);
  const [selectAll, setSelectAll] = useState(
    Object.values(cities).every((city) => city)
  );

  useEffect(() => {
    if (Object.values(cities).every((city) => city)) {
      setSelectAll(true);
    } else {
      if (selectAll) {
        setSelectAll(false);
      }
    }
  }, [cities]);

  const toggleCities = (e, { value }) => {
    const updatedCities = {
      ...cities,
      [value]: !cities[value],
    };

    setCities(updatedCities);
    localStorage.setItem('cities', JSON.stringify(updatedCities));
  };

  const generateCitiesCheckbox = () => {
    const sortedBySelected = Object.keys(cities).sort((a, b) => {
      if ((!cities[a] && !cities[b]) || (cities[a] && cities[b])) {
        return 0;
      } else if (!cities[a] && cities[b]) {
        return 1;
      } else {
        return -1;
      }
    });

    const sortedCities = sortedBySelected.reduce((result, city) => {
      result[city] = cities[city];
      return result;
    }, {});

    return Object.keys(sortedCities).map((city, index) => (
      <Checkbox
        key={index}
        name={city}
        label={city}
        value={city}
        checked={sortedCities[city]}
        onChange={toggleCities}
        className="city-checkbox"
      />
    ));
  };

  return (
    <div className="libraries-container">
      {generateCitiesCheckbox(openFullListModal).splice(0, 5)}
      <span className="more-options" onClick={() => setOpenFullListModal(true)}>
        ...更多選項
      </span>

      {openFullListModal ? (
        <Modal width={800}>
          <h2>選擇圖書館</h2>
          <Checkbox
            key={0}
            name="all"
            label="全選"
            checked={selectAll}
            onChange={() => {
              const updatedCities = { ...cities };
              Object.keys(updatedCities).forEach(
                (city) => (updatedCities[city] = !selectAll ? true : false)
              );

              localStorage.setItem('cities', JSON.stringify(updatedCities));
              setSelectAll(!selectAll);
              setCities(updatedCities);
            }}
            className="city-checkbox"
          />
          <div>{generateCitiesCheckbox(openFullListModal)}</div>
          <CloseIcon close={() => setOpenFullListModal(false)} />
        </Modal>
      ) : null}
    </div>
  );
};

export default CityCheckbox;
